<div class="container my-3 p-4">
  <div class="row">
    <div class="col-12">
      @if (category) {
      <h1 class="page-title">{{ category.title | globalTranslate }}</h1>
      }
    </div>
  </div>
  <div class="bg-white p-4">
    @if (category) {
    <div>
      <!-- Back Button -->
      <div class="faq-back-section mb-3">
        <button type="button" class="faq-back-btn" (click)="goBackToCategories()"
          [attr.aria-label]="('FAQ_BACK_TO_CATEGORIES' | globalTranslate) + (currentLang === 'en' ? ' (FAQs)' : '')">
          <!-- <i class="fa fa-arrow-left" aria-hidden="true"></i> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
            <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
              <path id="Combined_Shape" data-name="Combined Shape"
                d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
                transform="translate(0)" fill="#174a7c" />
            </g>
          </svg>
          <span class="span-back-btn">{{'FAQ_BACK_TO_CATEGORIES' | globalTranslate}}{{ currentLang === 'en'? ' (FAQs)' :
            '' }}</span>
        </button>
      </div>
      <!-- Questions List -->
      <div class="faq-revamp-container">
        @if (questions.length > 0) {
        <div id="faqAccordion" class="faq-search-results">
          @for (item of questions; track item; let i = $index) {
          <div class="faq-question-item">
            @if (isEligibilityAppealsHeader(item.key)) {
            <h2 class="faq-sub-heading">
              {{ "MY_ELIGIBILITY_APPEALS" | globalTranslate }}
            </h2>
            } @if (isEligibilityAppealsHeader(item.key)) {
            <hr class="faq-sub-heading-divider" />
            } @if (isMedicalAppealsHeader(item.key)) {
            <h2 class="faq-sub-heading medical-appeals-heading">
              {{ "MY_SUBMISSIONS_MA_HEADER" | globalTranslate }}
            </h2>
            } @if (isMedicalAppealsHeader(item.key)) {
            <hr class="faq-sub-heading-divider" />
            }
            <div class="faq-question-header" role="button" tabindex="0" [attr.aria-expanded]="item.show"
              [attr.aria-label]="
                (item.key | globalTranslate) +
                (item.show
                  ? ', ' + ('EXPANDED' | globalTranslate)
                  : ', ' + ('COLLAPSED' | globalTranslate))
              " [attr.aria-controls]="'faqCollapse' + i" (click)="showHide(item)" (keydown.enter)="showHide(item)"
              (keydown.space)="showHide(item); $event.preventDefault()">
              <div class="d-flex align-items-start">
                <p class="item-key">
                  <strong [innerHtml]="item.key | globalTranslate"></strong>
                </p>
                @if (item.show) {
                <div class="item-key-symbol" aria-hidden="true" role="presentation">
                  <i class="fa fa-angle-up"></i>
                </div>
                } @if (!item.show) {
                <div class="item-key-symbol" aria-hidden="true" role="presentation">
                  <i class="fa fa-angle-down"></i>
                </div>
                }
              </div>
            </div>
            <div [id]="'faqCollapse' + i" [ngClass]="{ show: item.show }" class="collapse text-width"
              aria-labelledby="headingOneFaqList" data-bs-parent="#faqAccordion">
              <div class="card-body">
                <p
                  [innerHtml]="item.value === 'FAQ_VALUE_46' ? (formatFaqAnswer(item.value) | globalTranslate) : (item.value | globalTranslate)">
                </p>
              </div>
            </div>
            @if (i
            < questions.length - 1 && !isEligibilityAppealsHeader(questions[i + 1]?.key) &&
              !isMedicalAppealsHeader(questions[i + 1]?.key)) { <hr [style.margin-top]="item.show ? '50px' : '30px'" />
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>